var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.25 67.25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.92 32.651l-10-19.479a3 3 0 00-2.67-1.63H79V9a9.01 9.01 0 00-9-9H9a9.01 9.01 0 00-9 9v38.5a9.011 9.011 0 007.071 8.786 13.154 13.154 0 0025.9.214h30.093a13.157 13.157 0 0025.87 0h16.316a3 3 0 003-3V34.021a3.008 3.008 0 00-.33-1.37zM79 17.543h14.418l6.92 13.479H79zM20.038 61.251a7.167 7.167 0 117.166-7.167 7.176 7.176 0 01-7.166 7.167zm43.3-10.75H32.696a13.157 13.157 0 00-25.2-.42 2.989 2.989 0 01-1.5-2.58v-38.5a3 3 0 013-3h61a3 3 0 013 3v32.274a13.2 13.2 0 00-9.654 9.226zm12.658 10.75a7.167 7.167 0 117.166-7.167A7.176 7.176 0 0176 61.251zm26.25-10.75H88.658A13.2 13.2 0 0079 41.275v-4.254h23.25z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "6e6949645891228a117ca533e7e5cdff.svg";
export { SvgTruck as ReactComponent };